import { supabase } from '../lib/supabase';

/**
 * Log an admin action to the audit_logs table.
 * @param {object} params
 * @param {string} params.action - e.g. 'CREATE', 'UPDATE', 'DELETE', 'SEND'
 * @param {string} params.module - e.g. 'lost_found', 'help_center', 'contacts', 'notifications', 'campus_map'
 * @param {string} [params.recordId] - ID of the affected record
 * @param {string} [params.recordSummary] - Brief description
 * @param {object} [params.metadata] - Additional context
 * @param {object} params.user - The current auth user object
 */
export async function logAuditAction({ action, module, recordId, recordSummary, metadata = {}, user }) {
  if (!user?.id) return;
  try {
    await supabase?.from('audit_logs')?.insert({
      admin_user_id: user?.id,
      admin_email: user?.email,
      admin_name: user?.user_metadata?.full_name || user?.email,
      action,
      module,
      record_id: recordId ? String(recordId) : null,
      record_summary: recordSummary || null,
      metadata,
    });
  } catch (err) {
    console.warn('Audit log failed (non-critical):', err);
  }
}
